{
  "actionbar.actions": "Actions",
  "actionbar.actionsAvailable": "Actions available.",
  "actionbar.clearSelection": "Clear selection",
  "actionbar.selected": "{count, plural, =0 {None selected} other {# selected}}",
  "actionbar.selectedAll": "All selected",
  "breadcrumbs.more": "More items",
  "button.pending": "pending",
  "calendar.invalidSelection": "Selected {selectedCount, plural, one {date} other {dates}} unavailable.",
  "combobox.noResults": "No results",
  "contextualhelp.help": "Help",
  "contextualhelp.info": "Information",
  "datepicker.endTime": "End time",
  "datepicker.startTime": "Start time",
  "datepicker.time": "Time",
  "dialog.alert": "Alert",
  "dialog.dismiss": "Dismiss",
  "dropzone.replaceMessage": "Drop file to replace",
  "inlinealert.informative": "Information",
  "inlinealert.negative": "Error",
  "inlinealert.notice": "Warning",
  "inlinealert.positive": "Success",
  "label.(optional)": "(optional)",
  "label.(required)": "(required)",
  "menu.moreActions": "More actions",
  "notificationbadge.indicatorOnly": "New activity",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Select…",
  "picker.selectedCount": "{count, plural, =0 {No items selected} one {# item selected} other {# items selected}}",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Cancel",
  "table.editCell": "Edit cell",
  "table.loading": "Loading…",
  "table.loadingMore": "Loading more…",
  "table.resizeColumn": "Resize column",
  "table.save": "Save",
  "table.sortAscending": "Sort Ascending",
  "table.sortDescending": "Sort Descending",
  "tag.actions": "Actions",
  "tag.hideButtonLabel": "Show less",
  "tag.noTags": "None",
  "tag.showAllButtonLabel": "Show all ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
